import React, { useState, useEffect } from "react";
import { Delete, ShieldCheck } from "lucide-react";

export const PinInput = ({ length = 4, onComplete, label = "Enter 4-digit PIN", error = "" }) => {
  const [pin, setPin] = useState("");

  useEffect(() => {
    if (pin.length === length) {
      onComplete && onComplete(pin);
    }
  }, [pin, length, onComplete]);

  useEffect(() => {
    if (error) setPin("");
  }, [error]);

  const press = (digit) => {
    if (pin.length < length) setPin((p) => p + digit);
  };

  const back = () => setPin((p) => p.slice(0, -1));

  const keys = ["1", "2", "3", "4", "5", "6", "7", "8", "9", "", "0", "back"];

  return (
    <div className="w-full flex flex-col items-center" data-testid="pin-input-container">
      <div className="flex items-center gap-2 mb-6">
        <ShieldCheck size={16} className="text-[#E6B455]" />
        <p className="text-sm text-[#F7E6B4]/70 font-medium">{label}</p>
      </div>
      <div className="flex gap-3 mb-4" data-testid="pin-dots">
        {Array.from({ length }).map((_, i) => (
          <div
            key={i}
            className={`pin-dot ${pin[i] ? "filled" : ""}`}
            data-testid={`pin-dot-${i}`}
          >
            {pin[i] ? "●" : ""}
          </div>
        ))}
      </div>
      {error && (
        <p className="text-sm text-red-400 mb-2" data-testid="pin-error">
          {error}
        </p>
      )}
      <div className="grid grid-cols-3 gap-5 mt-8">
        {keys.map((k, idx) =>
          k === "" ? (
            <div key={idx} />
          ) : k === "back" ? (
            <button
              key={idx}
              className="keypad-btn"
              onClick={back}
              data-testid="keypad-back"
              aria-label="Delete"
            >
              <Delete size={22} />
            </button>
          ) : (
            <button
              key={idx}
              className="keypad-btn"
              onClick={() => press(k)}
              data-testid={`keypad-${k}`}
            >
              {k}
            </button>
          )
        )}
      </div>
    </div>
  );
};
